import {
    Directive,
    Input,
    OnDestroy,
    TemplateRef,
    ViewContainerRef,
  } from '@angular/core';
  import { Store } from '@ngrx/store';
  import { Subject, combineLatest, takeUntil } from 'rxjs';
import { hasPermission } from '../../../core/permissions/permission.selector';

  @Directive({
    selector: '[appHasPermission]',
  })
  export class PermissionDirective implements OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(
      private viewContainerRef: ViewContainerRef,
      private templateRef: TemplateRef<any>,
      private store: Store
    ) {}

    @Input('appHasPermission') set hasPermission(input: string | string[]) {
      this.viewContainerRef.clear();

      if (typeof input === 'string') {
        this.checkPermission(input);
      } else if (Array.isArray(input)) {
        this.checkAnyPermission(input);
      } else {
        console.warn('Invalid appHasPermission input:', input);
      }
    }

    private checkPermission(permissionKey: string): void {
      this.store.select(hasPermission(permissionKey)).pipe(
        takeUntil(this.destroy$)
      ).subscribe((allowed) => {
        this.toggleView(allowed);
      });
    }

    private checkAnyPermission(keys: string[]): void {
      const observables = keys.map(key =>
        this.store.select(hasPermission(key))
      );

      combineLatest(observables).pipe(
        takeUntil(this.destroy$)
      ).subscribe(results => {
        const allowed = results.some(Boolean);
        this.toggleView(allowed);
      });
    }

    private toggleView(show: boolean): void {
      this.viewContainerRef.clear();
      if (show) {
        this.viewContainerRef.createEmbeddedView(this.templateRef);
      }
    }

    ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
    }
  }
